<template>
  <main>
    <v-toolbar dark class="primary elevation-0" fixed app extended>
      <v-toolbar-side-icon @click.stop="$root.$children[0]._data.drawer = !$root.$children[0]._data.drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Dashboard | Staging Platform</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-x :close-on-content-click="false" :nudge-width="200" v-model="showNotificationCenter" :max-width="500" v-if="isReferatsleitung">
        <v-btn slot="activator" icon>
          <v-badge overlap color="red">
            <span slot="badge" v-if="numberOfNotifications">{{ numberOfNotifications }}</span>
            <v-icon color="white">mail</v-icon>
          </v-badge>
        </v-btn>

        <v-card>
          <v-card-title style="padding-bottom: 0">
            <div class="title">Benachrichtigungen</div>
          </v-card-title>
          <v-list two-line>
            <v-list-tile v-if="!numberOfNotifications">
              <v-list-tile-content>
                Keine Benachrichtigungen
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(notification, index) in notifications">
              <v-list-tile :key="notification.text" :to="notification.action">
                <v-list-tile-content>
                  <v-list-tile-title v-html="notification.title"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="notification.text"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action @click="removeNotification(index)">
                  <v-btn icon ripple>
                    <v-icon class="grey--text text--lighten-1">close</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showNotificationCenter = false">Schließen</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-text-field solo prepend-icon="search" placeholder="Suchen..."></v-text-field>
      <v-btn icon>
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>help</v-icon>
      </v-btn>
    </v-toolbar>
    
    <v-content>
      <v-container grid-list-lg>
        <v-layout row>
          <v-flex xs12>
            <v-card class="card--flex-toolbar" style="margin-top: -76px; z-index: 3">
              <v-toolbar card prominent>
                <v-toolbar-title class="subheading">{{ isReferatsleitung ? 'Datensätze meiner Organisationseinheit' : 'Meine Datensätze' }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat>
                  <v-icon left>add</v-icon>
                  Datensatz erfassen
                </v-btn>
                <v-btn icon>
                  <v-icon>search</v-icon>
                </v-btn>
                <v-btn icon @click="viewAsGrid = !viewAsGrid">
                  <v-icon>apps</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="body-2 grey--text">Wählen Sie einen Datensatz, um fortzufahren. Verwenden Sie den "+"-Button, um einen neuen Datensatz hinzuzufügen.</v-card-text>
              <v-data-table v-if="!viewAsGrid" 
                :headers="headers"
                :items="datasetsMeta"
                v-model="selected"
                selected-key="name"
                :rows-per-page-text="'Zeilen pro Seite'"
                select-all>
                <template slot="items" scope="props">
                  <td>
                    <v-checkbox
                    primary
                    hide-details
                    v-model="props.selected"
                    ></v-checkbox>
                  </td>
                  <td>{{ props.item.name | ellipsis(40) }}</td>
                  <td class="text-xs-right">{{ props.item.date.modified }}</td>
                  <td class="text-xs-center">
                    <v-btn icon :to="'/erfassung/' + props.item.id">
                      <v-icon v-if="props.item.status.stepErfassung">check_circle</v-icon>
                      <v-icon v-else>highlight_off</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn icon :to="'/bewertung/' + props.item.id">
                      <v-icon v-if="props.item.status.stepBewertung">check_circle</v-icon>
                      <v-icon v-else>highlight_off</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn icon :to="'/aufwertung/' + props.item.id">
                      <v-icon v-if="props.item.status.stepAufwertung">check_circle</v-icon>
                      <v-icon v-else>highlight_off</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn icon :to="'/anonymisierung/' + props.item.id">
                      <v-icon v-if="props.item.status.stepAnonymisierung">check_circle</v-icon>
                      <v-icon v-else>highlight_off</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-right">{{ props.item.status.visibility }}</td>
                  <td class="text-xs-center">
                    <v-btn icon flat :to="'/erfassung/' + props.item.id">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
              <v-container fluid v-if="viewAsGrid" style="padding-top: 0" grid-list-lg>
                <v-layout row wrap>
                  <v-flex sm4 v-for="dataset in datasetsMeta" :key="dataset.id">
                    <v-card hover>
                      <v-card-title>
                        <div>
                          <h3 class="headline mb-0">{{ dataset.name | ellipsis(40) }}</h3>
                          <div>{{ dataset.description | ellipsis(70) }}</div>
                        </div>
                      </v-card-title>
                      <v-card-actions>
                        <v-btn flat primary :to="'/erfassung/' + dataset.id">View dataset</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3>
            <v-card class="blue white--text" hover :to="'/erfassung/'">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Erfassung</div>
                    </div>
                  </v-flex>
                  <v-flex xs5 class="text-xs-right">
                    <v-icon x-large>rate_review</v-icon>
                  </v-flex>
                </v-layout>
                <div>Erfassen Sie neue Datensätze oder bearbeiten Sie die Metadaten von bereits erfassten Datensätzen.</div>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex md3>
            <v-card class="blue lighten-2 white--text" hover :to="'/bewertung/'">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Bewertung</div>
                    </div>
                  </v-flex>
                  <v-flex xs5 class="text-xs-right">
                    <v-icon x-large>assessment</v-icon>
                  </v-flex>
                </v-layout>
                <div>Führen Sie Bewertungen für erfasste Datensätze anhand mehrerer Kriterien durch.</div>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex md3>
            <v-card class="blue darken-2 white--text" hover :to="'/aufwertung/'">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Aufwertung</div>
                    </div>
                  </v-flex>
                  <v-flex xs5 class="text-xs-right">
                    <v-icon x-large>chrome_reader_mode</v-icon>
                  </v-flex>
                </v-layout>
                <div>Mittels dieser Funktion können Sie Datensätze aufwerten, indem Sie bspw. Duplikate identifizieren und entfernen.</div>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex md3>
            <v-card class="blue-grey white--text" hover :to="'/anonymisierung/'">
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="headline">Anonymisierung</div>
                    </div>
                  </v-flex>
                  <v-flex xs5 class="text-xs-right">
                    <v-icon x-large>fingerprint</v-icon>
                  </v-flex>
                </v-layout>
                <div>Verwenden Sie diese Funktion, um personenbezogene Daten zu identifizieren und entfernen.</div>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    
  </main>
</template>

<script>
export default {
  computed: {
    datasetsMeta () {
      return this.$store.getters.getDatasetsMeta.data
    },
    isReferatsleitung () {
      return this.$store.getters.getIsReferatsleitung
    },
    notifications () {
      return this.$store.getters.getNotifications
    },
    numberOfNotifications () {
      if (this.notifications) return this.notifications.length
      return 0
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Name des Datensatzes',
          align: 'left',
          value: 'name'
        },
        { text: 'Zuletzt bearbeitet', value: 'date' },
        { text: 'Erfassung', align: 'center', value: 'status.stepErfassung' },
        { text: 'Bewertung', align: 'center', value: 'status.stepBewertung' },
        { text: 'Aufwertung', align: 'center', value: 'status.stepAufwertung' },
        { text: 'Anonymisierung', align: 'center', value: 'status.stepAnonymisierung' },
        { text: 'Status', value: 'status' }
      ],
      selected: [],
      viewAsGrid: false,
      showNotificationCenter: false
    }
  },
  methods: {
    removeNotification (index) {
      this.notifications.slice(index, 1)
    }
  },
  filters: {
    ellipsis (string, length = 50) {
      if (string) {
        if (string.length > length) return string.substring(0, length) + '...'
      }
      return string
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue